import { render } from "./StageRegions.vue?vue&type=template&id=4c8a304b&scoped=true"
import script from "./StageRegions.vue?vue&type=script&lang=js"
export * from "./StageRegions.vue?vue&type=script&lang=js"

import "./StageRegions.vue?vue&type=style&index=0&id=4c8a304b&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8a304b"]])

export default __exports__